import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter,
  Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

// RxJs
import { Observable } from 'rxjs';

// CDK
import { PgsSelectSearchComponent, IOption } from '@cdk/pgs-select-search';



@Component({
  selector: 'pgs-custom-list-cell',
  template: `
    <div class="d-flex align-items-center">
      <pgs-select-search #control [options]="_options" [noFilter]="10000" (selected)="select($event.value)"></pgs-select-search>
      <i *ngIf="!_options" class="ml-2 fa fa-spinner fa-spin fa-fw"></i>
    </div>`
})

export class CustomListCellComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() value: any;
  @Input() rowData: any;
  /*eslint-disable */ @Output() onSelect = new EventEmitter<any>();/*eslint-enable */
  @ViewChild('control', { static: true }) control: PgsSelectSearchComponent;

  _options: IOption[];
  options: IOption[] | Observable<IOption[]>;
  key: string;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
  }

  beforeInit: () => void = () => {
  }

  ngOnInit(): void {
    this.beforeInit();
    if (this.options instanceof Observable) {
      this.options.subscribe(options => {
        this._options = options;
        if (!this.changeDetectorRef['destroyed']) {
          this.changeDetectorRef.detectChanges();
        }
      });
    } else {
      this._options = this.options;
    }
  }

  ngAfterViewInit(): void {
    if (this.control && this.value && this.value[this.key]) {
      this.control.select(this.value[this.key]);
      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
    }
  }

  select(value: string): void {
    this.onSelect.emit({row: this.rowData, value: value});
  }

  ngOnDestroy(): void {
    this.changeDetectorRef.detach();
  }
}
